module.exports = __webpack_public_path__ + "img/bannerIcon03.bf7792db.png";